import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMedicamentosPersonalizadosTodos(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosPersonalizados/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getMedicamentoPersonalizado(context, id) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosPersonalizados/access/obter", {ID_MEDICAMENTO_PERSONALIZADO: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    deleteMedicamentoPersonalizado(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosPersonalizados/access/excluir", {ID_MEDICAMENTO_PERSONALIZADO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    postMedicamentoPersonalizado(context, medicamentoPersonalizado) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentosPersonalizados/access/salvar", medicamentoPersonalizado).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};